(function(){
'use strict';

// SVG icons (保持不变)
var WIFI='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.55a11 11 0 0 1 14.08 0M1.42 9a16 16 0 0 1 21.16 0M8.53 16.11a6 6 0 0 1 6.95 0M12 20h.01"/></svg>';
var INF='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M18.178 8c5.096 0 5.096 8 0 8-5.095 0-7.133-8-12.739-8-4.585 0-4.585 8 0 8 5.606 0 7.644-8 12.74-8z"/></svg>';
var CHK_S='<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#302F9E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
var CHK_M='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#302F9E" stroke-width="2.5" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>';
var XCL='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>';
var MSG='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#302F9E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>';
var INFO_CIRCLE='<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" fill="none" stroke="#6b7280" stroke-width="1.9"/><rect x="11.1" y="6.2" width="1.8" height="8.2" rx="0.9" fill="#6b7280"/><circle cx="12" cy="17.2" r="1.2" fill="#6b7280"/></svg>';

// Currency formatting (不变)
var _currEl=document.getElementById('nps-currency-data');
var _currData={symbol:'€',money:'1.00€'};
if(_currEl){try{_currData=JSON.parse(_currEl.textContent);}catch(e){}}
var _moneyStr=_currData.money;
var _numStr='1.00';
var _symStr=_moneyStr.replace(/[0-9.,\s]/g,'').trim()||'€';
var _symBefore=_moneyStr.indexOf(_symStr)<_moneyStr.indexOf('1');
function fmtPrice(n){
  var s=parseFloat(n).toFixed(2);
  return _symBefore?(_symStr+s):(s+' '+_symStr);
}

// Data & tiers (不变)
var dataEl=document.getElementById('nps-variant-data');
var PACKS={limited:[],unlimited:[]};
if(dataEl){try{PACKS=JSON.parse(dataEl.textContent);}catch(e){console.error('NPS parse error',e);}}
/* 👇 放在这里 */
['limited','unlimited'].forEach(function(t){
 (PACKS[t]||[]).forEach(function(p){

   var txt = (p.label||'') + ' ' + (p.sub||'');

   if(/\(popular\)/i.test(txt)){
     p.popular = true;
   }

   if(p.label){
     p.label = p.label.replace(/\s*\(popular\)/ig,'').trim();
   }

   if(p.sub){
     p.sub = p.sub.replace(/\s*\(popular\)/ig,'').trim();
   }

 });
});

//var DISCOUNT_RATE = 0.05;

/* x2 x3 x4+的优惠
var TIERS=[{min:1,max:1,d:0},{min:2,max:2,d:.15},{min:3,max:3,d:.18},{min:4,max:1/0,d:.20}];
function getTier(q){return TIERS.find(function(t){return q>=t.min&&q<=t.max;})||TIERS[0];}
*/

/* Confetti (不变) */
function confetti(el){
  var b=document.createElement('span');b.className='ncburst';b.setAttribute('aria-hidden','true');
  var C=['#a8d840','#302F9E','#facc15','#c8e89a','#fb923c','#2d6b12'];
  ['nca','ncb','ncc','ncd','nce','ncf'].forEach(function(cl,i){var p=document.createElement('span');p.className='ncp '+cl;var s=[12,10,8,12,8,8][i];p.style.cssText='width:'+s+'px;height:'+s+'px;background:'+C[i]+';margin-left:'+(-(s/2))+'px;margin-top:'+(-(s/2))+'px;';b.appendChild(p);});
  el.style.overflow='visible';el.appendChild(b);setTimeout(function(){if(b.parentNode)b.parentNode.removeChild(b);},960);
}

/* CTA HTML */
function ctaHtml(){
  var CART_ICO='<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';

  var activationHtml =
    '<div class="nps-activation" data-activation-wrap hidden>'
      + '<div class="nps-activation-hitbox">'
        + '<button type="button" class="nps-activation-btn" data-activation-btn>'
          + '<span class="nps-activation-k">Fecha de activación</span>'
          + '<span class="nps-activation-v" data-activation-value>Seleccionar</span>'
        + '</button>'
        + '<input type="date" class="nps-activation-native-date" data-activation-input>'
     + '</div> '  

      + '<div class="nps-activation-help" data-activation-help>'
        + '<span class="nps-activation-help-ico" aria-hidden="true">'+INFO_CIRCLE+'</span>'
        + '<span class="nps-activation-help-text">'
          + '<span class="nps-activation-help-line1">Elige la fecha de llegada a tu destino.</span>'
          + '<span class="nps-activation-help-line2">No actives tu eSIM antes de esa fecha.</span>'
        + '</span>'
      + '</div>'
      
      + '<div class="nps-activation-error" data-activation-error hidden>'
        + 'Selecciona una fecha de activación'
      + '</div>'
    + '</div>';

 var html =
  activationHtml +
  '<div class="nps-qrow"><span class="nps-qlbl">Qty</span><div class="nps-step"><button class="nps-sbtn" data-qm disabled>−</button><span class="nps-qval" data-qv>1</span><button class="nps-sbtn" data-qp>+</button></div></div>' +
  '<div class="nps-cta"><div class="nps-d-block"><div class="nps-d-badge" data-dbadge></div><div class="nps-d-top"><div class="nps-d-ico" data-ci>'+INF+'</div><div class="nps-d-pkg"><span class="nps-d-lbl" data-lbl-pkg></span><span class="nps-d-name" data-cn></span></div><div class="nps-d-pricecol"><span class="nps-d-orig" data-po></span><span class="nps-d-final" data-pf>—</span></div></div><div class="nps-d-divider"></div><div class="nps-d-bottom"><div class="nps-d-ppgrow"><span class="nps-d-ppg" data-ppg></span></div><div class="nps-d-chip" data-chip>🎉 <span data-disc></span> · save <span data-saved></span></div></div></div>';
  
  /* 只有系列开启了元字段才渲染备注框 */
  /*
  if(showNote) {
    html += '<div class="nps-note">'
      +'<label for="nps-note">Fecha de activación Europa <span style="color:red;">*</span></label>'
      +'<textarea id="nps-note" rows="3" placeholder="Solo para SIM local de Europa.&#10;Ingresa la fecha en este formato: YYYY-MM-DD&#10;Ejemplo: 2026-08-24" required></textarea>'
      +'</div>';
  }
  */
 
  html += '<button class="nps-btn nps-pulse" data-atc disabled>'+CART_ICO+' Agregar mi eSIM →</button></div>';
  return html;
}


/* 核心逻辑 — ，统一处理所有卡片/行 */
function wireLogic(root,getItems){
  var qty=1,sel=null;
  var QM=root.querySelector('[data-qm]'),QP=root.querySelector('[data-qp]'),QV=root.querySelector('[data-qv]');
  var CI=root.querySelector('[data-ci]'),CN=root.querySelector('[data-cn]');
  var LBPKG=root.querySelector('[data-lbl-pkg]');if(LBPKG)LBPKG.textContent=npsT('your_package')||'Your Package';
  var PO=root.querySelector('[data-po]'),PF=root.querySelector('[data-pf]');
  var DBADGE=root.querySelector('[data-dbadge]');
  var CHIP=root.querySelector('[data-chip]');
  var DISC=root.querySelector('[data-disc]');
  var SAVED=root.querySelector('[data-saved]');
  var PPG=root.querySelector('[data-ppg]');
  if(CN&&!CN.innerHTML)CN.innerHTML=npsT('select_plan')||'Select a plan';
  var ATB=root.querySelector('[data-atc]');
  var DISCOUNT_BTN=root.querySelector('[data-discount-btn]');

  if (ATB && !ATB.dataset.defaultLabel) {
    ATB.dataset.defaultLabel = ATB.innerHTML;
  }

  // ===== 这里开始新增 =====
  var activationDate = '';
  var config = { activation_date_mode: 'none', activation_min_offset: 0, activation_max_offset: 180 };

  var configEl = document.getElementById('nps-product-config');
  if (configEl) {
    try {
      var parsed = JSON.parse(configEl.textContent || '{}');
      config.activation_date_mode = parsed.activation_date_mode || 'none';
      config.activation_min_offset = parseInt(parsed.activation_min_offset || 0, 10);
      config.activation_max_offset = parseInt(parsed.activation_max_offset || 180, 10);
    } catch (e) {}
  }

  function needsActivationDate() {
    if (!sel) return false;

    var mode = config.activation_date_mode || 'none';

    if (mode === 'none') {
      return false;
    }

    if (mode === 'limited_only') {
      return sel.dataset.type === 'limited';
    }

    if (mode === 'all_variants') {
      return true;
    }

    if (mode === 'variant_control') {
      return sel.dataset.requiresActivationDate === 'true';
    }

    return false;
  }

  function syncActivationState() {
    var wrap = root.querySelector('[data-activation-wrap]');
    var btn = root.querySelector('[data-activation-btn]');
    var value = root.querySelector('[data-activation-value]');
    var error = root.querySelector('[data-activation-error]');
    var hidden = document.getElementById('selectedActivationDateInput');

    if (!wrap || !btn || !value || !hidden) return;

    if (needsActivationDate()) {
      wrap.hidden = false;
      value.textContent = activationDate || 'Seleccionar';
      btn.classList.toggle('is-selected', !!activationDate);
      ATB.disabled = !activationDate;
    } else {
      wrap.hidden = true;
      activationDate = '';
      hidden.value = '';
      value.textContent = 'Seleccionar';
      btn.classList.remove('is-selected');
      if (error) error.hidden = true;
      ATB.disabled = !sel;
    }
  }
  // ===== 新增结束 =====


  // ② 再放这里：选择日期按钮逻辑
  var activationBtn = root.querySelector('[data-activation-btn]');
  var activationInput = root.querySelector('[data-activation-input]');
  var activationError = root.querySelector('[data-activation-error]');
  var activationHidden = document.getElementById('selectedActivationDateInput');

  if (activationInput) {
    var today = new Date();
    var minOffset = parseInt(config.activation_min_offset || 0, 10);
    var maxOffset = parseInt(config.activation_max_offset || 180, 10);

    var minDate = new Date(today);
    minDate.setDate(minDate.getDate() + minOffset);

    var maxDate = new Date(today);
    maxDate.setDate(maxDate.getDate() + maxOffset);

    activationInput.min = minDate.toISOString().split('T')[0];
    activationInput.max = maxDate.toISOString().split('T')[0];
  }

  if (activationBtn && activationInput) {
    activationBtn.addEventListener('click', function () {
      if (!needsActivationDate()) return;

      try {
        if (typeof activationInput.showPicker === 'function') {
          activationInput.showPicker();
          return;
        }
      } catch (e) {}

      activationInput.focus({ preventScroll: true });
      setTimeout(function () {
        activationInput.click();
      }, 0);
    });

    activationInput.addEventListener('change', function () {
      activationDate = this.value || '';
      if (activationHidden) activationHidden.value = activationDate;
      if (activationError) activationError.hidden = true;
      syncActivationState();
    });
  }


  function upPrice(){
    if(!sel){
      CN.textContent = npsT('select_plan');
      PF.textContent = '—';

      if (PO) PO.style.display = 'none';
      if (DBADGE) DBADGE.classList.remove('show');
      if (CHIP) CHIP.classList.remove('show');
      if (DISC) DISC.textContent = '';
      if (SAVED) SAVED.textContent = '';
      if (PPG) PPG.textContent = '';

      return;
    }

    var u = parseFloat(sel.dataset.price),
        gb = parseFloat(sel.dataset.gb) || 0;

    // 只按数量计算正常总价，不再有任何折扣逻辑
    var tf = +(u * qty).toFixed(2);

    var _gb = sel.dataset.gb,
        _days = sel.dataset.days,
        _type = sel.dataset.type,
        _carrier = sel.dataset.carrier || '';

    var _mainLbl = '';

    if (_type === 'unlimited') {
      _mainLbl = (_carrier ? _carrier + ' ' : '') + 'Ilimitados';
    } else {
      _mainLbl = (_carrier ? _carrier + ' ' : '') + (gb > 0 ? (gb + 'GB') : '');
    }

    var _subLbl = '';
    if (_days && _days !== 'undefined') {
      _subLbl = ' · ' + _days;
    }

    var _qtyLbl = qty > 1 ? ' <span class="nps-d-qty">× ' + qty + '</span>' : '';

    CN.innerHTML =
      '<span class="nps-d-lbl-main">' + _mainLbl + '</span>' +
      '<span class="nps-d-lbl-sub">' + _subLbl + '</span>' +
      _qtyLbl;

    // 不显示 ppg / ppd
    if (PPG) {
      PPG.innerHTML = '';
    }

    // 强制关闭所有折扣 UI
    if (PO) PO.style.display = 'none';
    if (DBADGE) DBADGE.classList.remove('show');
    if (CHIP) CHIP.classList.remove('show');
    if (DISC) DISC.textContent = '';
    if (SAVED) SAVED.textContent = '';

    // 保留价格变化动画
    PF.textContent = fmtPrice(tf);
    PF.classList.remove('nps-ap');
    void PF.offsetWidth;
    PF.classList.add('nps-ap');

    var vi = document.getElementById('selectedVariantInput'),
        qi = document.getElementById('selectedQtyInput');

    if (vi && sel.dataset.variantId) vi.value = sel.dataset.variantId;
    if (qi) qi.value = qty;
  }

  function upTiers(){
  QM.disabled=qty<=1;
  QP.disabled=qty>=10;
  QV.textContent=qty;
  }

  /*
  function upTiers(){
    root.querySelectorAll('[data-tm]').forEach(function(b){
      var m=parseInt(b.dataset.tm);
      b.classList.toggle('on',m===4?qty>=4:qty===m);
    });
    QM.disabled=qty<=1;QP.disabled=qty>=10;QV.textContent=qty;
  }
  */

  function pick(el){
    getItems(root).forEach(function(c){ c.classList.remove('on'); });
    el.classList.add('on');
    sel = el;
    CI.innerHTML = el.dataset.type === 'unlimited' ? INF : WIFI;
    upPrice();
    syncActivationState();
  }

  function switchTab(tab){
    requestAnimationFrame(function(){
      root.querySelectorAll('.nps-tab').forEach(function(b){b.classList.toggle('on',b.dataset.t===tab);});
      root.querySelectorAll('.nps-panel').forEach(function(p){p.classList.toggle('on',p.dataset.p===tab);});
      var panel=root.querySelector('[data-p="'+tab+'"]');
      var first=panel.querySelector('[data-price]');
      if(first&&!panel.querySelector('.on'))pick(first);
    });
  }

  function setQty(v){
  qty=Math.max(1,Math.min(10,v));
    upTiers();
    upPrice();
  }
  
  /*
  function setQty(v){
    qty=Math.max(1,Math.min(10,v));
    upTiers();
    upPrice();  // 统一调用 upPrice（不再区分 unlimited）
  }
  */

  // 事件绑定：tab切换
  root.querySelectorAll('.nps-tab').forEach(function(b){
    b.addEventListener('click',function(){switchTab(b.dataset.t);});
  });

  QM.addEventListener('click',function(){
    setQty(qty-1);
  });

  /*
  QM.addEventListener('click',function(){
    setQty(qty-1);
    var tb=root.querySelector('[data-tm="'+qty+'"]')||(qty>=4?root.querySelector('[data-tm="4"]'):null);
    if(tb)confetti(tb);
  });
  */

  QP.addEventListener('click',function(){
    setQty(qty+1);
    confetti(PF);
  });

  /*
  QP.addEventListener('click',function(){
    setQty(qty+1);
    confetti(PF);
    var tb=root.querySelector('[data-tm="'+qty+'"]')||(qty>=4?root.querySelector('[data-tm="4"]'):null);
    if(tb)confetti(tb);
  });
  */

  root.querySelectorAll('[data-tm]').forEach(function(b){
    b.addEventListener('click',function(){setQty(parseInt(b.dataset.tm));confetti(b);confetti(PF);});
  });

  root.addEventListener('click',function(e){
    var c=e.target.closest('[data-price]');
    if(c)pick(c);
  });

ATB.addEventListener('click', async function() {
  var vi = document.getElementById('selectedVariantInput');
  var qi = document.getElementById('selectedQtyInput');
  var form = document.getElementById('nps-cart-form');

  if (!vi || !vi.value || !form || !sel) return;

  // 新逻辑：如果当前套餐必须选择激活日期，但还没选，则禁止加购
  if (needsActivationDate() && !activationDate) {
    if (activationError) activationError.hidden = false;
    if (activationBtn) activationBtn.focus();
    ATB.disabled = true;
    return;
  }

  // 同步数量
  if (qi) {
    qi.value = qty;
  }

  // 同步激活日期到 line item property
  // 前提：main-product.liquid 里已经常驻这个 hidden input
  // <input type="hidden" name="properties[Fecha de activación]" id="selectedActivationDateInput" value="">
  if (activationHidden) {
    activationHidden.value = needsActivationDate() ? (activationDate || '') : '';
  }

  var oldHtml = ATB.innerHTML;
  ATB.innerHTML = 'Agregando…';
  ATB.disabled = true;

  try {
    var formData = new FormData(form);

    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    });

    var data = await res.json();

    if (!res.ok) {
      throw new Error((data && data.description) || 'Error al agregar al carrito');
    }

    // 只更新自定义 header 气泡，不再手动渲染原生 drawer
    if (window.updateHeaderCartCount) {
      window.updateHeaderCartCount();
    }

    // 通知其他系统刷新（AOV 若有监听可自行处理）
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'nps-product' } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'nps-product' } }));
    window.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'nps-product' } }));

    // 可选：如果你发现 AOV 对 cart:refresh 没反应，也可以再补一个延迟兜底
    setTimeout(function () {
      if (window.updateHeaderCartCount) {
        window.updateHeaderCartCount();
      }
    }, 300);

    // 可选：加购成功后清掉错误提示
    if (activationError) activationError.hidden = true;

  } catch (err) {
    console.error(err);
    alert((err && err.message) || 'No se pudo agregar al carrito. Inténtalo de nuevo.');
  } finally {
    ATB.innerHTML = oldHtml;
    syncActivationState();
  }
});

  // 默认选中最受欢迎或第一个
  var pop=
    root.querySelector('.nps-panel.on [data-popular="true"]') ||
    root.querySelector('.nps-panel.on [data-price]') ||
    root.querySelector('[data-p="limited"] [data-popular="true"]') ||
    root.querySelector('[data-p="limited"] [data-price]') ||
    root.querySelector('[data-p="unlimited"] [data-popular="true"]') ||
    root.querySelector('[data-p="unlimited"] [data-price]');
  if(pop)pick(pop);

  upTiers();

  if (!root.dataset.pageshowBound) {
    root.dataset.pageshowBound = '1';

    window.addEventListener('pageshow', function(e) {
      if (!e.persisted) return;

      // 如果页面从 bfcache 恢复，重新按当前状态计算按钮可用性
      syncActivationState();

      // 可选：确保按钮文案不是缓存中的“Agregando…”
      if (ATB) {
        ATB.innerHTML = ATB.dataset.defaultLabel || ATB.innerHTML;
      }
    });
  }
}

var isMob=true; // 始终使用 row 布局（你原代码如此）

function buildSelector(rootId){
  var root=document.getElementById(rootId);if(!root)return;
  //这里判断有没有 limited
  var hasLimited = PACKS.limited && PACKS.limited.length > 0;
  //这里判断有没有 unlimited
  var hasUnlimited = PACKS.unlimited && PACKS.unlimited.length > 0;

  // Trust pills 数据 (不变)
  var _ICO_MAIL='<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>';
  var _ICO_BOLT='<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>';
  var _ICO_WIFI='<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12.55a11 11 0 0 1 14.08 0M1.42 9a16 16 0 0 1 21.16 0M8.53 16.11a6 6 0 0 1 6.95 0M12 20h.01"/></svg>';
  var _ICO_SHIELD='<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>';
  var _ICO_MSG='<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>';
  var _ICO_LOCK='<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/><circle cx="7" cy="15" r="1.5" fill="currentColor" stroke="none"/></svg>';
  var _PAY='<div style="display:flex;align-items:center;gap:5px;margin-top:3px"><svg viewBox="0 0 38 24" width="26" height="16"><circle cx="15" cy="12" r="10" fill="#EB001B"/><circle cx="23" cy="12" r="10" fill="#F79E1B"/><path d="M19 5.3a10 10 0 0 1 0 13.4A10 10 0 0 1 19 5.3z" fill="#FF5F00"/></svg><span style="height:15px;padding:0 5px;border:1px solid #ddd;background:#fff;border-radius:3px;color:#1A1F71;font-size:8px;font-weight:800;display:inline-flex;align-items:center">VISA</span><span style="height:15px;padding:0 5px;background:#016FD0;border-radius:3px;color:#fff;font-size:8px;font-weight:800;display:inline-flex;align-items:center">AMEX</span></div>';
  
  var _CELLS=[
    {ico:_ICO_MAIL,  lbl:'Vía Correo', sub:'código QR y indicación',            muted:false},
    {ico:_ICO_BOLT,  lbl:'Activación rápido',  sub:'Instalar en 5mins',  muted:false},
    {ico:_ICO_WIFI,  lbl:'5G / 4G',          sub:'Velocidad local',          muted:false},
    {ico:_ICO_SHIELD,lbl:'7-días reembolso',    sub:'Cero riesgo',            muted:false},
    {ico:_ICO_MSG,   lbl:'24/7 ayuda',     sub:'Siempre disponible',     muted:false},
    {ico:_ICO_LOCK,  lbl:'Pago seguro',   sub:_PAY,                   muted:false},
  ];

// HTML 结构：两个 tab 所有套餐都是 unlimited 时 不再显示 Datos Limitados 不再显示 Datos Limitados YOUR PACKAGE 会跟着 unlimited 的第一个套餐走
var defaultTab = hasLimited ? 'limited' : 'unlimited';

var html = '<div class="nps"><div class="nps-tabs">';

if(hasLimited){
  html += '<button class="nps-tab' + (defaultTab === 'limited' ? ' on' : '') + '" data-t="limited"><span class="ti">'+WIFI+'</span>'+npsT('limited_data')+'</button>';
}

if(hasUnlimited){
  html += '<button class="nps-tab' + (defaultTab === 'unlimited' ? ' on' : '') + '" data-t="unlimited"><span class="ti">'+INF+'</span>'+npsT('unlimited_data')+'</button>';
}

html += '</div>';

if(hasLimited){
  html += '<div class="nps-panel' + (defaultTab === 'limited' ? ' on' : '') + '" data-p="limited"><div class="nps-rows-wrap" data-g="limited"></div></div>';
}

if(hasUnlimited){
  html += '<div class="nps-panel' + (defaultTab === 'unlimited' ? ' on' : '') + '" data-p="unlimited"><div class="nps-rows-wrap" data-g="unlimited"></div></div>';
}

/* 数码猫原本的代码 这里把 limited tab 永远写死输出了，即使 PACKS.limited.length === 0，这个 tab 还是会显示。
// HTML 结构：两个 tab 都用一样的列表容器
var html='<div class="nps"><div class="nps-tabs">'
+'<button class="nps-tab on" data-t="limited"><span class="ti">'+WIFI+'</span>'+npsT('limited_data')+'</button>';

if(hasUnlimited){
  html+='<button class="nps-tab" data-t="unlimited"><span class="ti">'+INF+'</span>'+npsT('unlimited_data')+'</button>';
}

html+='</div>';
  
  // 统一使用 row 布局（因为 isMob=true）
  html+='<div class="nps-panel on" data-p="limited"><div class="nps-rows-wrap" data-g="limited"></div></div>';

if(hasUnlimited){
  html+='<div class="nps-panel" data-p="unlimited"><div class="nps-rows-wrap" data-g="unlimited"></div></div>';
} */
  
  html+=ctaHtml()+'</div>';
  root.innerHTML=html;

/*这一段是下面的优化，但效果是只有一个 tab 时”整个 tabs 容器隐藏掉了
if((hasLimited && !hasUnlimited) || (!hasLimited && hasUnlimited)){
  var tabs = root.querySelector('.nps-tabs');
  if(tabs) tabs.style.display='none';
}

/* 如果没有 unlimited 就隐藏 tabs */
/*
if(!hasUnlimited){
  var tabs = root.querySelector('.nps-tabs');
  if(tabs) tabs.style.display='none';
}
*/  
  // Trust pills (不变)
  var _tp=document.createElement('div');
  _tp.id='tp-shopify';
  var _tpGrid=document.createElement('div');
  _tpGrid.className='tp-grid';
  _CELLS.forEach(function(c){
    var el=document.createElement('div');
    el.className='tp-cell';
    el.innerHTML='<div class="tp-ico'+(c.muted?' muted':'')+'">'+c.ico+'</div>'
      +'<div class="tp-body"><div class="tp-lbl'+(c.muted?' muted':'')+'">'+c.lbl+'</div>'
      +(c.muted?c.sub:'<div class="tp-sub">'+c.sub+'</div>')+'</div>';
    _tpGrid.appendChild(el);
  });
  _tp.appendChild(_tpGrid);
  root.querySelector('.nps').appendChild(_tp);

  // 生成 limited 卡片
// 生成 limited 卡片（修改版，拆分 GB 和天数）
var fLim = document.createDocumentFragment();
PACKS.limited.forEach(function(p){
  var el = document.createElement('div');
  el.className = 'nps-row' + (p.popular ? ' nps-pop' : '');

/* 数码猫原本的代码  
  // 拆分 GB 和天数
  var _gbMatch = (p.label||'').match(/(\d+\s*GB)/i);
  var _gbTr = _gbMatch ? _gbMatch[1] : p.label;           // 5GB
  var _subTr = (p.label||'').replace(_gbTr,'').trim() || p.sub; // 30Días 或 fallback
  var _subNum = parseInt((_subTr.match(/\d+/)||[])[0]) || 0;
  var _tDayL = _subNum === 1 ? 'Día' : 'Días';
  if(_subNum > 0) _subTr = _subNum + ' ' + _tDayL;
*/

  // 新增拆分 运营商 / GB / 天数
  var _fullLabel = (p.label || '').trim();

  var _gbMatch = _fullLabel.match(/(\d+\s*GB)/i);
  var _gbTr = _gbMatch ? _gbMatch[1] : '';

  var _dayMatch = _fullLabel.match(/(\d+\s*D[ií]a?s?)/i);
  var _subTr = _dayMatch ? _dayMatch[1] : (p.sub || '');

  var _carrierTr = _fullLabel
    .replace(_gbTr, '')
    .replace(_subTr, '')
    .replace(/\(popular\)/ig, '')
    .replace(/\s+/g, ' ')
    .trim();

  var _subNum = parseInt((_subTr.match(/\d+/) || [])[0]) || 0;
  var _tDayL = _subNum === 1 ? 'Día' : 'Días';
  if (_subNum > 0) _subTr = _subNum + ' ' + _tDayL;

  // GB 数值
  var _gbNum = parseFloat((_gbTr.match(/(\d+)/)||[])[1]) || 0;

  // dataset
  el.dataset.price = p.price;
  el.dataset.gb = _gbNum;
  el.dataset.days = _subTr;
  el.dataset.daysN = _subNum;
  el.dataset.label = _gbTr + ' · ' + _subTr;
  el.dataset.carrier = _carrierTr;
  el.dataset.type = 'limited';
  el.dataset.popular = p.popular;
  el.dataset.variantId = p.id;
  el.dataset.requiresActivationDate = p.requires_activation_date ? 'true' : 'false';

  // 每 GB 价格
  var ppg_lim = _gbNum > 0 ? fmtPrice(p.price / _gbNum) + '/GB' : '';

  el.innerHTML = (p.popular ? '<div class="nps-row-pbadge">'+npsT('most_popular')+'</div>' : '')
    + '<div class="nps-row-radio"><div class="nps-row-checkmark"></div></div>'
    + '<div class="nps-row-ico">'+WIFI+'</div>'
    + '<div class="nps-row-body">'
      + '<span class="nps-row-label">'+(_carrierTr ? _carrierTr + ' ' : '') + _gbTr+'</span>'
      + '<span class="nps-row-meta">'+_subTr+'</span>'
      //这一段控制显示运营商/价格/GB
    /*
    + '<div class="nps-row-body">'
      + '<span class="nps-row-label">'+_gbTr+'</span>'
      + '<span class="nps-row-meta">'+_subTr+'</span>'
    //数码猫 这一段控制显示价格/GB + (ppg_lim ? '<span class="nps-row-ppg-group"><span class="nps-row-sep"> · </span><span class="nps-row-pricepergb">'+ppg_lim+'</span></span>' : '')
    */
    + '</div>'
    + '<span class="nps-row-price">'+fmtPrice(p.price)+'</span>';

  fLim.appendChild(el);
});
  // 生成 unlimited 卡片 — 现在和 limited 一样格式

var fUnl = document.createDocumentFragment();

PACKS.unlimited.forEach(function(p){
  var el = document.createElement('div');
  el.className = 'nps-row' + (p.popular ? ' nps-pop' : '');

  var _fullLabel = (p.label || '').trim();

  // 先从原始标题里提取“原始天数字串”
  var _dayMatch = _fullLabel.match(/(\d+)\s*D[ií]a?s?/i);
  var _daysN = _dayMatch ? parseInt(_dayMatch[1], 10) : 0;
  var _daysRaw = _dayMatch ? _dayMatch[0] : '';

  var _tDay = _daysN === 1 ? 'Día' : 'Días';
  var _daysLabel = _daysN > 0 ? (_daysN + ' ' + _tDay) : '';

  // 从原始标题里剥离出运营商名
  var _carrierTr = _fullLabel
    .replace(_daysRaw, '')
    .replace(/datos?\s+ilimitados?/ig, '')
    .replace(/ilimitados?/ig, '')
    .replace(/unlimited/ig, '')
    .replace(/\(popular\)/ig, '')
    .replace(/\s+/g, ' ')
    .trim();

  el.dataset.price = p.price;
  el.dataset.gb = '';
  el.dataset.days = _daysLabel;
  el.dataset.daysN = _daysN;
  el.dataset.label = (_carrierTr ? _carrierTr + ' ' : '') + 'Ilimitados';
  el.dataset.carrier = _carrierTr;
  el.dataset.type = 'unlimited';
  el.dataset.popular = p.popular;
  el.dataset.variantId = p.id;
  el.dataset.requiresActivationDate = p.requires_activation_date ? 'true' : 'false';

  el.innerHTML =
    (p.popular ? '<div class="nps-row-pbadge">' + npsT('most_popular') + '</div>' : '') +
    '<div class="nps-row-radio"><div class="nps-row-checkmark"></div></div>' +
    '<div class="nps-row-ico">' + INF + '</div>' +
    '<div class="nps-row-body">' +
      '<span class="nps-row-label">' + (_carrierTr ? _carrierTr + ' ' : '') + 'Ilimitados</span>' +
      '<span class="nps-row-meta">' + _daysLabel + '</span>' +
    '</div>' +
    '<span class="nps-row-price">' + fmtPrice(p.price) + '</span>';

  fUnl.appendChild(el);
});

/*  
  var fUnl=document.createDocumentFragment();

  PACKS.unlimited.forEach(function(p){
    var el = document.createElement('div');
    el.className = 'nps-row' + (p.popular ? ' nps-pop' : '');

    var _fullLabel = (p.label || '').trim();

    var _dayMatch = _fullLabel.match(/(\d+\s*D[ií]a?s?)/i);
    var _daysLabel = _dayMatch ? _dayMatch[1] : '';

    var _daysN = parseInt((_daysLabel.match(/\d+/) || [])[0]) || parseFloat(p.days) || 0;
    var _tDay = _daysN === 1 ? 'Día' : 'Días';
    if (_daysN > 0) _daysLabel = _daysN + ' ' + _tDay;
    if (!_daysLabel) _daysLabel = 'Ilimitados';

    var _carrierTr = _fullLabel
      .replace(/datos?\s+ilimitados?/ig, '')
      .replace(/ilimitados?/ig, '')
      .replace(/unlimited/ig, '')
      .replace(_daysLabel, '')
      .replace(/\(popular\)/ig, '')
      .replace(/\s+/g, ' ')
      .trim();

    el.dataset.price = p.price;
    el.dataset.gb = '';
    el.dataset.days = _daysLabel;
    el.dataset.daysN = _daysN;
    el.dataset.label = (_carrierTr ? _carrierTr + ' ' : '') + 'Ilimitados · ' + _daysLabel;
    el.dataset.carrier = _carrierTr;
    el.dataset.type = 'unlimited';
    el.dataset.popular = p.popular;
    el.dataset.variantId = p.id;

    el.innerHTML =
      (p.popular ? '<div class="nps-row-pbadge">' + npsT('most_popular') + '</div>' : '') +
      '<div class="nps-row-radio"><div class="nps-row-checkmark"></div></div>' +
      '<div class="nps-row-ico">' + INF + '</div>' +
      '<div class="nps-row-body">' +
        '<span class="nps-row-label">' + (_carrierTr ? _carrierTr + ' ' : '') + 'Ilimitados</span>' +
        '<span class="nps-row-meta">' + _daysLabel + '</span>' +
      '</div>' +
      '<span class="nps-row-price">' + fmtPrice(p.price) + '</span>';

    fUnl.appendChild(el);
  });
  */
  /*这里同样是把运营商彻底写死丢掉了
  PACKS.unlimited.forEach(function(p){
    var el=document.createElement('div');
    el.className='nps-row'+(p.popular?' nps-pop':'');
    var _daysN=parseFloat(p.days)||0;
    var _tDay=_daysN===1?'Día':'Días';
    var _daysLabel=_daysN>0?_daysN+' '+_tDay:'Ilimitados';
    el.dataset.price=p.price;
    el.dataset.gb='';
    el.dataset.days=_daysLabel;
    el.dataset.daysN=_daysN;
    el.dataset.label='Ilimitados · '+_daysLabel;
    el.dataset.type='unlimited';
    el.dataset.popular=p.popular;
    el.dataset.variantId=p.id;

    var ppd=_daysN>0?fmtPrice(parseFloat(p.price)/_daysN)+'<span class="nps-d-ppg-unit">/Día</span>':'';
    el.innerHTML=(p.popular?'<div class="nps-row-pbadge">'+npsT('most_popular')+'</div>':'')
      +'<div class="nps-row-radio"><div class="nps-row-checkmark"></div></div>'
      +'<div class="nps-row-ico">'+INF+'</div>'
      +'<div class="nps-row-body"><span class="nps-row-label">Ilimitados</span><span class="nps-row-meta">'+_daysLabel+'</span>'
      //这一段控制显示价格/GB +(ppd?'<span class="nps-row-ppg-group"><span class="nps-row-sep"> · </span><span class="nps-row-pricepergb">'+ppd+'</span></span>':'')
      +'</div><span class="nps-row-price">'+fmtPrice(p.price)+'</span>';

    fUnl.appendChild(el);
  });
  */

    // 渲染 limited
  if(hasLimited){
    var limitedWrap = root.querySelector('[data-g="limited"]');
    if(limitedWrap){
      limitedWrap.appendChild(fLim);
    }
  }

  // 渲染 unlimited
  if(hasUnlimited){
    var unlimitedWrap = root.querySelector('[data-g="unlimited"]');
    if(unlimitedWrap){
      unlimitedWrap.appendChild(fUnl);
    }
  }

  /*
  root.querySelector('[data-g="limited"]').appendChild(fLim);
  if(hasUnlimited){
  root.querySelector('[data-g="unlimited"]').appendChild(fUnl);
  }
  */
  // 绑定逻辑（getItems 统一返回所有 .nps-row）
  wireLogic(root,function(r){return r.querySelectorAll('.nps-row');});
}


function buildCC(cid){
  var container=document.getElementById(cid);if(!container)return;
  container.innerHTML='<div class="cc-wrap"><div class="cc-inner"><div class="cc-head"><div class="cc-ico">'+MSG+'</div><div class="cc-titles"><span class="cc-eyebrow">Check Device</span><div class="cc-title">eSIM Compatible?</div></div><button class="cc-auto" data-ca>Auto-detect</button></div><div data-cr></div><div class="cc-search"><div class="cc-sfield" data-csf><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="2.5"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg><input type="text" placeholder="Search — iPhone 16, Galaxy S25, Honor Magic 7…" data-si autocomplete="off"/><span data-sis></span></div><div class="cc-dd" data-cdd style="display:none"></div><div data-cil></div></div></div></div>';
  var CA=container.querySelector('[data-ca]'),CR=container.querySelector('[data-cr]');
  var CSF=container.querySelector('[data-csf]'),SI=container.querySelector('[data-si]');
  var SIS=container.querySelector('[data-sis]'),CDD=container.querySelector('[data-cdd]'),CIL=container.querySelector('[data-cil]');
  // iOS detection: physical pixels (logical * DPR) are unique per model
  // Source: Apple hardware specs
  function detectiOSModel(){
    var sw=window.screen.width,sh=window.screen.height,dpr=window.devicePixelRatio||1;
    var pw=Math.round(Math.min(sw,sh)*dpr); // physical width portrait
    var ph=Math.round(Math.max(sw,sh)*dpr); // physical height portrait
    var key=pw+'x'+ph;
    var PHYS={
      // ── iPhone (physical px portrait) ──
      '640x960' :'iPhone 4 / 4S',
      '640x1136':'iPhone 5 / 5C / 5S / SE (2016)',
      '750x1334':'iPhone 6 / 6S / 7 / 8 / SE (2020) / SE (2022)',
      '828x1792':'iPhone XR / 11',
      '1080x1920':'iPhone 6 Plus / 6S Plus / 7 Plus / 8 Plus',
      '1125x2436':'iPhone X / XS / 11 Pro',
      '1242x2208':'iPhone 6 Plus / 6S Plus / 7 Plus / 8 Plus',
      '1242x2688':'iPhone XS Max / 11 Pro Max',
      '1080x2340':'iPhone 12 mini / 13 mini',
      '1170x2532':'iPhone 12 / 12 Pro / 13 / 13 Pro / 14',
      '1284x2778':'iPhone 12 Pro Max / 13 Pro Max / 14 Plus',
      '1179x2556':'iPhone 14 Pro / 15 / 15 Pro',
      '1290x2796':'iPhone 14 Pro Max / 15 Plus / 15 Pro Max',
      '1206x2622':'iPhone 16 / 16 Pro',
      '1320x2868':'iPhone 16 Plus / 16 Pro Max',
      '1320x2868_air':'iPhone 16e',
      // ── iPad (physical px landscape short side) ──
      '1536x2048':'iPad (older)',
      '1668x2224':'iPad Pro 10.5 / Air 3',
      '1668x2388':'iPad Pro 11',
      '2048x2732':'iPad Pro 12.9',
    };
    var mdl=PHYS[key];
    if(mdl)return mdl;
    // Fallback: try to narrow by logical resolution
    var lkey=Math.min(sw,sh)+'x'+Math.max(sw,sh);
    var LOGI={
      '375x667':'iPhone 6 / 7 / 8 / SE',
      '375x812':'iPhone X / XS / 11 Pro',
      '414x736':'iPhone 6 Plus / 7 Plus / 8 Plus',
      '414x896':'iPhone XR / XS Max / 11 / 11 Pro Max',
      '360x780':'iPhone 12 mini / 13 mini',
      '390x844':'iPhone 12 / 12 Pro / 13 / 13 Pro / 14',
      '428x926':'iPhone 12 Pro Max / 13 Pro Max / 14 Plus',
      '393x852':'iPhone 14 Pro / 15 / 15 Pro',
      '430x932':'iPhone 14 Pro Max / 15 Plus / 15 Pro Max',
      '402x874':'iPhone 16 / 16 Pro',
      '440x956':'iPhone 16 Plus / 16 Pro Max',
      '320x568':'iPhone 5 / 5S / SE (2016)',
    };
    return LOGI[lkey]||null;
  }
  CA.addEventListener('click',function(){
    CR.innerHTML='<div class="cc-detecting c-slide"><div class="cc-spin"></div><span style="font-size:12.5px;font-weight:600;color:#888">Analyzing your device…</span></div>';
    CA.style.display='none';
    setTimeout(function(){
      var ua=navigator.userAgent,mob=/android|iphone|ipad|mobile/i.test(ua);
      function addReset(){var rb=document.createElement('button');rb.className='cc-reset';rb.textContent='Reset';rb.onclick=function(){CR.innerHTML='';CA.style.display='';SI.value='';CDD.style.display='none';CIL.innerHTML='';SIS.innerHTML='';CSF.className='cc-sfield';};CR.appendChild(rb);}
      function showOk(name){CR.innerHTML='<div class="cc-res-ok c-slide"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#302F9E" stroke-width="2.5" stroke-linecap="round" class="c-pop"><polyline points="20 6 9 17 4 12"/></svg><div><div class="cc-res-t" style="color:#2d6b12">eSIM Compatible ✓</div><div class="cc-res-s" style="color:#302F9E">'+name+' detected</div></div></div>';addReset();}
      function showUnk(){CR.innerHTML='<div class="cc-res-unk c-slide"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg><div><div class="cc-res-t" style="color:#92400e">Could not auto-detect</div><div class="cc-res-s" style="color:#b45309">Search your model below</div></div></div>';addReset();}
      function detectDevice(ua){
        // ── Samsung (SM-XXXX codes) ──
        var smMatch=ua.match(/SM-([A-Z0-9]+)/i);
        if(smMatch){
          var c=smMatch[1].toUpperCase();
          var SMAP={
            // S25 series
            'S938':'Samsung Galaxy S25 Ultra','S936':'Samsung Galaxy S25+','S931':'Samsung Galaxy S25','S921E':'Samsung Galaxy S25 Edge',
            // S24 series
            'S928':'Samsung Galaxy S24 Ultra','S926':'Samsung Galaxy S24+','S921':'Samsung Galaxy S24','S741':'Samsung Galaxy S24 FE',
            // S23 series
            'S918':'Samsung Galaxy S23 Ultra','S916':'Samsung Galaxy S23+','S911':'Samsung Galaxy S23','S711':'Samsung Galaxy S23 FE',
            // S22 series
            'S908':'Samsung Galaxy S22 Ultra','S906':'Samsung Galaxy S22+','S901':'Samsung Galaxy S22',
            // S21 series
            'G998':'Samsung Galaxy S21 Ultra','G996':'Samsung Galaxy S21+','G991':'Samsung Galaxy S21','G990':'Samsung Galaxy S21 FE',
            // S20 series
            'G988':'Samsung Galaxy S20 Ultra','G986':'Samsung Galaxy S20+','G981':'Samsung Galaxy S20','G781':'Samsung Galaxy S20 FE',
            // Note
            'N986':'Samsung Galaxy Note 20 Ultra','N981':'Samsung Galaxy Note 20',
            // Z Fold
            'F956':'Samsung Galaxy Z Fold 6','F946':'Samsung Galaxy Z Fold 5','F936':'Samsung Galaxy Z Fold 4','F926':'Samsung Galaxy Z Fold 3','F916':'Samsung Galaxy Z Fold 2',
            // Z Flip
            'F741':'Samsung Galaxy Z Flip 6','F731':'Samsung Galaxy Z Flip 5','F721':'Samsung Galaxy Z Flip 4','F711':'Samsung Galaxy Z Flip 3',
            // A series
            'A566':'Samsung Galaxy A56','A556':'Samsung Galaxy A55','A546':'Samsung Galaxy A54',
            'A366':'Samsung Galaxy A36','A356':'Samsung Galaxy A35',
            // Tab S10
            'X910':'Samsung Galaxy Tab S10 Ultra','X810':'Samsung Galaxy Tab S10+','X710':'Samsung Galaxy Tab S10',
            // Tab S9
            'X916':'Samsung Galaxy Tab S9 Ultra','X816':'Samsung Galaxy Tab S9+','X716':'Samsung Galaxy Tab S9',
            // Tab S8
            'X906':'Samsung Galaxy Tab S8 Ultra','X806':'Samsung Galaxy Tab S8+','X706':'Samsung Galaxy Tab S8',
          };
          for(var k in SMAP){if(c.indexOf(k)===0)return SMAP[k];}
          return 'Samsung '+smMatch[0];
        }
        // ── Google Pixel (exact model in UA) ──
        var px=ua.match(/Pixel\s*([\w\s]+?)(?:\s+Build|;|\))/i);
        if(px){
          var pname=px[1].trim().replace(/\s+/g,' ');
          return 'Google Pixel '+pname;
        }
        // ── OnePlus ──
        var op=ua.match(/(?:OnePlus|ONEPLUS)[_ /]([A-Z0-9]+)/i);
        if(op)return 'OnePlus '+op[1];
        // ── Xiaomi / Redmi / POCO ──
        var xi=ua.match(/(?:Xiaomi|Redmi|POCO)[_ ]([^\s;/]+(?:\s[^\s;/]+)?)/i);
        if(xi)return xi[0].split(/Build|;/)[0].trim().replace(/[_]/g,' ');
        // ── Motorola ──
        var mo=ua.match(/motorola\s+([A-Za-z0-9 ]+?)(?:\s+Build|;)/i);
        if(mo)return 'Motorola '+mo[1].trim();
        // ── Sony Xperia ──
        var so=ua.match(/XQ-([A-Z0-9]+)/i);
        if(so){
          var SONY={'AT52':'Xperia 1 III','BT52':'Xperia 1 IV','CQ54':'Xperia 1 V','EC54':'Xperia 1 VI',
                    'BQ52':'Xperia 5 III','CQ62':'Xperia 5 IV','DQ72':'Xperia 5 V',
                    'BE52':'Xperia 10 III','BT52':'Xperia 10 IV','CC54':'Xperia 10 V'};
          return 'Sony Xperia '+(SONY[so[1].toUpperCase()]||so[0]);
        }
        // ── Huawei ──
        var hw=ua.match(/(?:ELS|VOG|ANA|NOH|JAD|OCE|CLT|INE)-[A-Z0-9]+/i);
        if(hw)return 'Huawei ('+hw[0]+')';
        // ── Generic: extract device name between ; and Build/ ──
        var gen=ua.match(/;\s*([^;()]+?)\s+Build\//i);
        if(gen&&gen[1].length>2&&gen[1].length<45){
          var name=gen[1].trim();
          // Filter out OS strings
          if(!/android|linux|mobile|tablet/i.test(name))return name;
        }
        return null;
      }

      if(!mob){CR.innerHTML='<div class="cc-res-no c-slide"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2.5" stroke-linecap="round" class="c-shake"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg><div><div class="cc-res-t" style="color:#dc2626">Desktop detected</div><div class="cc-res-s" style="color:#f87171">eSIM not supported on desktops</div></div></div>';addReset();}
      else{
        var ios=ua.match(/OS (\d+)/i),iosN=ios?parseInt(ios[1]):0;
        if(/iphone/i.test(ua)&&iosN>=12){
          var mdl=detectiOSModel()||'iPhone';
          showOk(mdl+' (iOS '+iosN+')');
        } else if(/android/i.test(ua)){
          var androidModel=detectDevice(ua);
          if(androidModel){
            var ml=androidModel.toLowerCase();
            // Check compatibility — try exact then partial match
            var matchedModel=null;
            for(var i=0;i<MODELS_LC.length;i++){
              var m=MODELS_LC[i];
              if(m.low===ml||m.low.indexOf(ml)>=0||(ml.length>5&&ml.indexOf(m.low)>=0)){
                matchedModel=m.label;break;
              }
            }
            // Also try word-by-word matching for generic Android detections
            if(!matchedModel){
              var words=ml.split(/\s+/).filter(function(w){return w.length>2;});
              for(var i=0;i<MODELS_LC.length;i++){
                var hits=words.filter(function(w){return MODELS_LC[i].low.indexOf(w)>=0;});
                if(hits.length>=2){matchedModel=MODELS_LC[i].label;break;}
              }
            }
            if(matchedModel){showOk(matchedModel);}
            else{
              CR.innerHTML='<div class="cc-res-no c-slide"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2.5" stroke-linecap="round" class="c-shake"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg><div><div class="cc-res-t" style="color:#dc2626">'+androidModel+' — Not compatible</div><div class="cc-res-s" style="color:#f87171">Your device does not support eSIM</div></div></div>';addReset();
            }
          } else {showUnk();}
        } else {showUnk();}
      }
    },1300);
  });
  SI.addEventListener('input',function(){
    if(SI._dbt)clearTimeout(SI._dbt);
    SI._dbt=setTimeout(function(){
    var q=SI.value.trim().toLowerCase();CIL.innerHTML='';CDD.style.display='none';
    if(!q){CSF.className='cc-sfield';SIS.innerHTML='';return;}
    var matches=MODELS_LC.filter(function(m){return m.low.indexOf(q)>=0;}).map(function(m){return m.label;});
    if(matches.length>0){
      CSF.className='cc-sfield ok';SIS.innerHTML='<span class="c-pop" style="color:#302F9E;display:flex">'+CHK_S+'</span>';
      var frag=document.createDocumentFragment();
      var hdr=document.createElement('div');hdr.className='cc-dd-hdr';hdr.textContent=matches.length+' compatible model'+(matches.length>1?'s':'');frag.appendChild(hdr);
      matches.slice(0,8).forEach(function(m){var item=document.createElement('div');item.className='cc-dd-item';item.innerHTML='<div class="cc-dd-chk">'+CHK_S+'</div>'+m;item.addEventListener('mousedown',function(){SI.value=m;CDD.style.display='none';CIL.innerHTML='<div class="cc-inline-ok">'+CHK_M+' Compatible with eSIM</div>';CSF.className='cc-sfield ok';});frag.appendChild(item);});
      CDD.innerHTML='';CDD.appendChild(frag);CDD.style.display='block';
    }else if(q.length>=4){
      CSF.className='cc-sfield no';SIS.innerHTML='<span class="c-shake" style="color:#ef4444;display:flex">'+XCL+'</span>';
      CIL.innerHTML='<div class="cc-inline-no">'+XCL+' Not found in our compatible devices list</div>';
    }else{CSF.className='cc-sfield';SIS.innerHTML='';}
    },120);
  });
  document.addEventListener('click',function(e){if(!container.contains(e.target))CDD.style.display='none';},{passive:true});
}

buildSelector('nps-shopify');
buildCC('cc-shopify-top');buildCC('cc-shopify');
})();